module.exports = __webpack_public_path__ + "static/img/14000052.fc242f77.png";